var map = {
	"./about/belief-1.jpg": 97,
	"./about/belief-2.jpg": 98,
	"./about/icon-of-christ.jpg": 99,
	"./about/orthodoxy-2.jpg": 100,
	"./about/orthodoxy-3.jpg": 101,
	"./bg.jpg": 294,
	"./buildingproject/render-front-aerial-view.png": 62,
	"./buildingproject/render-front-view.png": 63,
	"./buildingproject/render-rear-view.png": 64,
	"./buildingproject/site-plan.png": 65,
	"./buildingproject/us.jpg": 102,
	"./church-domes.png": 81,
	"./concrete-bg.jpg": 295,
	"./holy-cross.png": 82,
	"./holycross-logo.png": 80,
	"./ministries/adult-education.jpg": 296,
	"./ministries/archangel-michael.jpg": 297,
	"./ministries/church-school.jpg": 298,
	"./ministries/food-closet-volunteers.jpg": 103,
	"./ministries/ocf.jpg": 299,
	"./ministries/orthodox-faith-and-life.jpg": 300,
	"./ministries/st-xenia-volunteers.jpg": 104,
	"./ministries/st-xenia.jpg": 301,
	"./news/brewfest-flyer-2019.pdf": 72,
	"./news/church-domes.jpg": 105,
	"./news/newsletter-april-2023-1.jpg": 106,
	"./news/newsletter-april-2023-2.jpg": 107,
	"./news/newsletter-april-2023-3.jpg": 108,
	"./news/newsletter-april-2023-4.jpg": 109,
	"./news/newsletter-april-2023-5.png": 110,
	"./news/newsletter-april-2023-6.jpg": 111,
	"./news/newsletter-april-2023-7.jpg": 112,
	"./news/newsletter-august-2021-building-program.jpg": 113,
	"./news/newsletter-august-2021-holy-cross.jpg": 114,
	"./news/newsletter-august-2021-joe-laychak.jpg": 115,
	"./news/newsletter-august-2021-pilgrimage.jpg": 116,
	"./news/newsletter-august-2021-raul-and-lily.jpg": 117,
	"./news/newsletter-december-2018-food-closet.jpg": 118,
	"./news/newsletter-december-2018-fundraiser.jpg": 119,
	"./news/newsletter-december-2018-icon.jpg": 120,
	"./news/newsletter-december-2021-1.jpg": 121,
	"./news/newsletter-december-2021-building-program.jpg": 122,
	"./news/newsletter-december-2021-christmas.jpg": 123,
	"./news/newsletter-december-2021-feast-day.jpg": 124,
	"./news/newsletter-december-2021-wine-stroll.jpg": 125,
	"./news/newsletter-december-2022-1.jpg": 126,
	"./news/newsletter-december-2022-10.jpg": 127,
	"./news/newsletter-december-2022-2.jpg": 128,
	"./news/newsletter-december-2022-3.jpg": 129,
	"./news/newsletter-december-2022-4.jpg": 130,
	"./news/newsletter-december-2022-5.jpg": 131,
	"./news/newsletter-december-2022-6.jpg": 132,
	"./news/newsletter-december-2022-7.jpg": 133,
	"./news/newsletter-december-2022-8.jpg": 134,
	"./news/newsletter-december-2022-9.jpg": 135,
	"./news/newsletter-december-2023-1.jpg": 136,
	"./news/newsletter-december-2023-2.jpg": 137,
	"./news/newsletter-december-2023-3.jpg": 138,
	"./news/newsletter-december-2023-4.jpg": 139,
	"./news/newsletter-december-2023-5.jpg": 140,
	"./news/newsletter-december-2023-6.jpg": 141,
	"./news/newsletter-december-2023-7.jpg": 142,
	"./news/newsletter-july-2019-archbishop-john-shahovskoy.png": 143,
	"./news/newsletter-july-2019-fair.jpg": 144,
	"./news/newsletter-july-2019-manton-retreat.jpg": 145,
	"./news/newsletter-june-2018-church-model.jpg": 42,
	"./news/newsletter-june-2018-hike.jpg": 146,
	"./news/newsletter-june-2018-icon.jpg": 302,
	"./news/newsletter-june-2018-miter.jpg": 147,
	"./news/newsletter-march-2019-blessing.jpg": 148,
	"./news/newsletter-march-2019-matching.jpg": 149,
	"./news/newsletter-march-2019-retreat.jpg": 150,
	"./news/newsletter-march-2022-1.jpg": 151,
	"./news/newsletter-march-2022-2.jpg": 152,
	"./news/newsletter-march-2022-3.png": 153,
	"./news/newsletter-march-2022-4.png": 154,
	"./news/newsletter-march-2022-bennie-brock.jpg": 155,
	"./news/newsletter-may-2021-archbishop-benjamin-message.jpg": 156,
	"./news/newsletter-may-2021-blessings.jpg": 157,
	"./news/newsletter-may-2021-breaking-the-fast.jpg": 158,
	"./news/newsletter-may-2021-paschal-divine-liturgy.jpg": 159,
	"./news/newsletter-may-2021-readings.jpg": 160,
	"./news/newsletter-may-2021-surveying.jpg": 161,
	"./news/newsletter-november-2024-1.jpg": 303,
	"./news/newsletter-november-2024-2.jpg": 304,
	"./news/newsletter-november-2024-3.jpg": 305,
	"./news/newsletter-november-2024-4.jpg": 306,
	"./news/newsletter-september-2018-camp.png": 162,
	"./news/newsletter-september-2018-food-closet.png": 163,
	"./news/newsletter-september-2018-st-innocent.png": 164,
	"./news/wine-stroll-flyer-2018.pdf": 73,
	"./news/wine-stroll-flyer-2019.pdf": 74,
	"./news/wine-stroll-flyer-2021.pdf": 75,
	"./oca-logo.png": 165,
	"./prayer-rope.png": 83,
	"./profile/archbishop-benjamin.jpg": 307,
	"./profile/dn-joseph.jpg": 308,
	"./profile/dn-seraphim.jpg": 309,
	"./profile/fr-andrew.jpg": 310,
	"./profile/fr-david.jpg": 311,
	"./profile/fr-ian.jpg": 312,
	"./profile/fr-stephen.jpg": 313,
	"./profile/fr-timothy.jpg": 314,
	"./profile/fr-tom.jpg": 315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;